'use es6';

import PropTypes from 'prop-types';
import { Fragment } from 'react';
import { HR } from 'foundations-components/transitional/components/HR';
import ProgressiveProfilingConfiguration from 'FormsUI/components/editor/form/configuration/ProgressiveProfilingConfiguration';
import DependentFieldsConfiguration from 'FormsUI/components/editor/form/configuration/DependentFieldsConfiguration';
import updateFormFieldKey from 'forms-utils-lib/formField/utils/updateFormFieldKey';
import FormFieldKeys from 'forms-utils-lib/constants/formField/FormFieldKeys';
import createFormField from 'forms-utils-lib/formField/utils/createFormField';
import LogicConfigUpgradeSection from './LogicConfigUpgradeSection';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LogicConfig = ({
  formField = createFormField({}),
  mainAndQueuedFieldsByPropertyId = {},
  dependentFieldsByPropertyId = {},
  propertiesById = {},
  numberFormFieldsWithinGroup = 1,
  userPreferredLocale = '',
  shouldShowProgressive = false,
  shouldShowDependentFields = false,
  isFormLabelPropertyEnabled = false,
  haveAccessToLogicConfig = false,
  isCookieTrackingDisabled = false,
  updateFormField = () => {},
  addDependentField = () => {},
  editDependentField = () => {},
  removeDependentField = () => {}
}) => /*#__PURE__*/_jsxs("div", {
  children: [!haveAccessToLogicConfig && /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(LogicConfigUpgradeSection, {}), /*#__PURE__*/_jsx(HR, {})]
  }), shouldShowProgressive && /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(ProgressiveProfilingConfiguration, {
      "data-editable-field": "profilling",
      formField: formField,
      updateSmartField: (_, isSmart) => updateFormField(updateFormFieldKey(formField, FormFieldKeys.IS_SMART_FIELD, isSmart)),
      disableSelect: isCookieTrackingDisabled,
      disableFields: !haveAccessToLogicConfig
    }), /*#__PURE__*/_jsx(HR, {})]
  }), shouldShowDependentFields && /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(DependentFieldsConfiguration, {
      updateFormField: updateFormField,
      formField: formField,
      mainAndQueuedFieldsByPropertyId: mainAndQueuedFieldsByPropertyId,
      dependentFieldsByPropertyId: dependentFieldsByPropertyId,
      propertiesById: propertiesById,
      addDependentField: addDependentField,
      editDependentField: editDependentField,
      removeDependentField: removeDependentField,
      numberFormFieldsWithinGroup: numberFormFieldsWithinGroup,
      isFormLabelPropertyEnabled: isFormLabelPropertyEnabled,
      disableFields: !haveAccessToLogicConfig,
      userPreferredLocale: userPreferredLocale
    }), /*#__PURE__*/_jsx(HR, {})]
  })]
});
LogicConfig.propTypes = {
  updateFormField: PropTypes.func,
  formField: PropTypes.object,
  numberFormFieldsWithinGroup: PropTypes.number,
  shouldShowProgressive: PropTypes.bool,
  shouldShowDependentFields: PropTypes.bool,
  isFormLabelPropertyEnabled: PropTypes.bool,
  mainAndQueuedFieldsByPropertyId: PropTypes.object,
  dependentFieldsByPropertyId: PropTypes.object,
  haveAccessToLogicConfig: PropTypes.bool,
  propertiesById: PropTypes.object,
  addDependentField: PropTypes.func,
  editDependentField: PropTypes.func,
  removeDependentField: PropTypes.func,
  onUpgradeClick: PropTypes.func,
  isCookieTrackingDisabled: PropTypes.bool,
  userPreferredLocale: PropTypes.string
};
export default LogicConfig;